// Stable, no-auth participant identity for Area Search Coordinator. Mirrors
// Video Canvass's "no login, the link is the permission" model — a
// participant is just a random id the browser remembers, plus a chosen name.

const COLOR_PALETTE = [
  '#e11d48', '#2563eb', '#16a34a', '#d97706',
  '#7c3aed', '#0891b2', '#db2777', '#65a30d',
  '#c2410c', '#4338ca',
];

// Shorter than Canvass's 22-char makeId() since this id is never itself the
// access-control secret (the searchId is) — it only needs to be unique
// enough to not collide with other participants in the same search.
function makeId(len = 12) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const arr = new Uint32Array(len);
  crypto.getRandomValues(arr);
  let s = '';
  for (let i = 0; i < len; i++) s += chars[arr[i] % chars.length];
  return s;
}

function hashCode(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

const identityKey = searchId => `areasearch_${searchId}_identity`;
const LAST_NAME_KEY = 'areasearch_displayName';

// Loads (or creates) this browser's identity for a given search — a random
// participant id and an assigned color, persisted so a reload keeps the same
// trail/color instead of starting over as a new participant. displayName is
// '' until saveParticipantName() is called; the caller must not silently
// default it, since sharing consent should be confirmed each session.
export function loadOrCreateParticipant(searchId) {
  const key = identityKey(searchId);
  try {
    const raw = localStorage.getItem(key);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && parsed.participantId && parsed.color) return parsed;
    }
  } catch {
    // corrupt storage — fall through and create a fresh identity
  }
  const participantId = makeId();
  const color = COLOR_PALETTE[hashCode(participantId) % COLOR_PALETTE.length];
  const identity = { participantId, color, displayName: '' };
  try { localStorage.setItem(key, JSON.stringify(identity)); } catch {}
  return identity;
}

// Confirms a display name for this search's identity, and remembers it as
// the suggested prefill (not auto-applied) for the next search this browser joins.
export function saveParticipantName(searchId, displayName) {
  const identity = loadOrCreateParticipant(searchId);
  identity.displayName = displayName;
  try {
    localStorage.setItem(identityKey(searchId), JSON.stringify(identity));
    localStorage.setItem(LAST_NAME_KEY, displayName);
  } catch {}
  return identity;
}

export function getLastDisplayName() {
  try { return localStorage.getItem(LAST_NAME_KEY) || ''; } catch { return ''; }
}
